import React from "react";

const Amount = ({ transfer }) => {
  if (transfer.is_convert) {
    return (
      <>
        {transfer.gross_amount} {transfer.source_currency}{" "}
        <i className="fa fa-arrow-right" /> {transfer.net_amount}{" "}
        {transfer.destination_currency === "USDT"
          ? "USD"
          : transfer.destination_currency}
      </>
    );
  }

  return `${transfer.net_amount} ${
    transfer.destination_currency === "USDT"
      ? "USD"
      : transfer.destination_currency
  }`;
};

export default Amount;
